import {Component, Input} from '@angular/core';

@Component({
    selector: 'wba-nachweise-info',
    templateUrl: './nachweise-info.component.html',
    standalone: false
})
export class NachweiseInfoComponent {

  @Input() _id = 'id';

}
